<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Select CSV to import" header-tag="h4" class="mb-4">
        <div class="row">
          <div class="col-12">
            <h4 class="font-weight-bold bp_color mb-2">IMPORTING A NEW FILE removes the EXISTING DATA IN HOLDING</h4>
          </div>
          <div class="col-lg-6">
            <p>
              <span class="font-weight-bold">Please select the CSV file provided to import the worker into holding.</span><br><br>
              Once you have then checked the worker details click the 'Import into CRM' button to import them into the CRM.
            </p>
          </div>
          <div class="col-lg-6">
            <uploadInput @file-chosen="update_import_file($event)"
                         :accepted_file_type="'.csv'"
                         :selected_file="workerImportFile"
                         :hidden_id="'worker_import_file'"
                         style="margin-bottom: 10px;"

            ></uploadInput>

            <button class="btn orcaBtn w-100"
                    @click.prevent="import_file_to_holding()"
                    :class="{'disabled': workerImportFile === null}"
                    :disabled="workerImportFile === null">Import into Holding
            </button>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-12" v-if="holding.length > 0">
      <!--    <div class="col-12">-->
      <hr class="mt-4">
      <h3 class="ml-3">WORKER READY TO IMPORT <i>(Please check information)</i></h3>
      <div class="worker_exists" v-if="website_email_exists || ni_number_exists">
        <div class="we_notice">
          <i class="fas fa-exclamation-triangle"></i> &nbsp;
          <span v-if="website_email_exists && !ni_number_exists">Website Email matched an existing worker record</span>
          <span v-else-if="ni_number_exists && !website_email_exists">NI Number matched an existing worker record</span>
          <span v-else-if="website_email_exists && ni_number_exists">Website Email and NI Number matched an existing worker record</span>
        </div>
        <div class="we_btn">
          <button class="btn orcaBtn greenBtn sm_btn w-100" @click.prevent="go_to_profile()">Go To Profile</button>
        </div>
      </div>
      <div v-else class="row ml-3 mr-3 mt-3">
        <div class="col-lg-5">
          <div class="row">
            <label class="col-7 cardLabel" for="send_welcome_email">Send Welcome Email</label>
            <div class="col-5">
              <bootstrap-toggle v-model="send_welcome_email" name="send_welcome_email" id="send_welcome_email" :options="{ on: 'Yes', off: 'No' }"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2"></div>
        <div class="col-lg-5">
          <button class="btn orcaBtn w-100" @click.prevent="import_worker" :class="{'disabled': importing}" :disabled="importing">
            <span v-if="importing" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Importing Worker ...</span>
            <span v-else>Import Worker</span>
          </button>
        </div>
      </div>
      <!--      SEND WELCOME EMAIL -->
      <!--      IMPORT -> return error if match on website login or ni number found -->
      <hr class="mt-3">
      <div class="row">
        <div class="col-12 record" v-for="hold in holding">
          <b-tabs content-class="mt-3" justified pills>
            <b-tab title="PERSONAL INFO" active>
              <div class="row">
                <div class="col-12">
                  <b-card header="Personal Information" header-tag="h4" class="mb-4 record_card_body">
                    <div class="row">
                      <!-- Title -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="title">Title</label>
                        <p id="title"><span v-if="check_not_null(hold.data.person.title_id)">{{ get_person_title(hold.data.person.title_id) }}</span><span v-else>&nbsp;</span></p>
                      </div>
                      <!-- First Name -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="first_name">First Name(s)</label>
                        <p id="first_name"><span v-if="check_not_null(hold.data.person.first_name)">{{ hold.data.person.first_name }}</span><span v-else>&nbsp;</span></p>
                      </div>
                      <!-- Surname -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="surname">Surname</label>
                        <p id="surname"><span v-if="check_not_null(hold.data.person.surname)">{{ hold.data.person.surname }}</span><span v-else>&nbsp;</span></p>
                      </div>
                      <!-- D.O.B -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="dob">Date of Birth</label>
                        <p id="dob"><span v-if="check_not_null(hold.data.person.dob)">{{ hold.data.person.dob | formatDate }}</span><span v-else>&nbsp;</span></p>
                      </div>
                      <!-- NI Number -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="ni_number">NI Number</label>
                        <p id="ni_number"><span v-if="check_not_null(hold.data.worker_profile.ni_number)">{{ hold.data.worker_profile.ni_number }}</span><span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Nationality -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="nationality">Nationality</label>
                        <p id="nationality">
                          <span v-if="check_not_null(hold.data.person.nationality_id)">{{ get_person_nationality(hold.data.person.nationality_id) }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Is UK Citizen -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="nationality">UK Citizen</label>
                        <p id="is_uk_citizen"><span v-if="hold.data.person.is_uk_citizen">Yes</span><span v-else>No</span></p>
                      </div>
                    </div>
                  </b-card>
                </div>
                <div class="col-lg-6">
                  <b-card header="Primary / Website Login Email" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                    <div class="row">
                      <!-- Login Email Address -->
                      <div class="col-12 form-group">
                        <label class="form-label" for="website_login_email">Login Email Address</label>
                        <p id="website_login_email">
                          <span v-if="check_email_exists('website_login', hold.data)">{{ get_email('website_login', hold.data) }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                    </div>
                  </b-card>
                </div>
                <div class="col-lg-6">
                  <b-card header="Current Employment Status" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                    <div class="row">
                      <!-- Current Status -->
                      <div class="col-xl-6 form-group">
                        <label class="form-label" for="employment_status">Current Status</label>
                        <p id="employment_status">
                          <span v-if="check_not_null(hold.data.worker_company_info.employment_type_id)">
                            {{ get_current_employment_type(hold.data.worker_company_info.employment_type_id) }}
                          </span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Job Title -->
                      <div class="col-xl-6 form-group">
                        <label class="form-label" for="job_title">Job Title</label>
                        <p id="job_title">
                          <span v-if="check_not_null(hold.data.worker_profile.job_title_id)">{{ get_job_title(hold.data.worker_profile.job_title_id) }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                    </div>
                  </b-card>
                </div>
                <div class="col-lg-8">
                  <b-card header="Personal Contact Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                    <div class="row">
                      <!-- Mobile Number -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="mobile">Mobile Number</label>
                        <p id="mobile">
                          <span v-if="check_phone_exists('personal_mobile', hold.data)">{{ get_phone('personal_mobile', hold.data) }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Landline Phone Number -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="telephone">Landline Phone Number</label>
                        <p id="telephone">
                          <span v-if="check_phone_exists('personal_landline', hold.data)">{{ get_phone('personal_landline', hold.data) }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Personal Email Address -->
                      <div class="col-lg-4 form-group">
                        <label class="form-label" for="personal_email">Personal Email Address</label>
                        <p id="personal_email">
                          <span v-if="check_email_exists('person_email', hold.data)">{{ get_email('person_email', hold.data) }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                    </div>
                    <div class="row" v-if="check_address_exists('home_address', hold.data)">
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <!-- Personal Address -->
                      <div class="col-12">
                        <h5 class="font-weight-bold">Personal Address</h5>
                      </div>
                      <!-- Full Address -->
                      <div class="col-12 form-group">
                        <label class="form-label" for="h_address_full">Full Address</label>
                        <p id="h_address_full">{{ get_address_full('home_address', hold.data) }}</p>
                      </div>
                      <!-- Home Building -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="h_address_building">Building</label>
                        <p id="h_address_building">{{ get_address_building('home_address', hold.data) }}</p>
                      </div>
                      <!-- Home Street -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="h_address_street">Street</label>
                        <p id="h_address_street">{{ get_address_street('home_address', hold.data) }}</p>
                      </div>
                      <!-- Home Locality -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="h_address_locality">Locality</label>
                        <p id="h_address_locality">{{ get_address_locality('home_address', hold.data) }}</p>
                      </div>
                      <!-- Home City/Town -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="h_address_city_town">City / Town</label>
                        <p id="h_address_city_town">{{ get_address_city_town('home_address', hold.data) }}</p>
                      </div>
                      <!-- Home County -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="h_address_county">County</label>
                        <p id="h_address_county">{{ get_address_county('home_address', hold.data) }}</p>
                      </div>
                      <!-- Home Postcode -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="h_address_postcode">Postcode</label>
                        <p id="h_address_postcode">{{ get_address_postcode('home_address', hold.data) }}</p>
                      </div>
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                    </div>
                    <div class="row">
                      <!-- Next of Kin -->
                      <div class="col-12">
                        <h5 class="font-weight-bold">Next of Kin Information</h5>
                      </div>
                      <!-- NOK Full Name -->
                      <div class="col-xl-6 form-group">
                        <label class="form-label" for="nok_name">Contact Name</label>
                        <p id="nok_name">
                          <span v-if="check_not_null(hold.data.worker_profile.nok_name)">{{ hold.data.worker_profile.nok_name }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- NOK Contact Number -->
                      <div class="col-xl-6 form-group">
                        <label class="form-label" for="nok_number">Contact Number</label>
                        <p id="nok_number">
                          <span v-if="check_not_null(hold.data.worker_profile.nok_contact_number)">{{ hold.data.worker_profile.nok_contact_number }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                    </div>
                  </b-card>
                </div>
                <div class="col-lg-4">
                  <b-card header="Personal Bank Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                    <div class="row" v-if="check_bank_exists('personal', hold.data)">
                      <!-- Bank Name -->
                      <div class="col-lg-12 col-md-4 form-group">
                        <label class="form-label" for="bank_name">Bank Name</label>
                        <p id="bank_name">{{ get_bank_name('personal', hold.data) }}</p>
                      </div>
                      <!-- Branch Location -->
                      <div class="col-lg-12 col-md-4 form-group">
                        <label class="form-label" for="branch_location">Branch Location</label>
                        <p id="branch_location">{{ get_bank_branch_location('personal', hold.data) }}</p>
                      </div>
                      <!-- Account Holder Name('s) -->
                      <div class="col-lg-12 col-md-4 form-group">
                        <label class="form-label" for="accounts_holder">Account Holder Name('s)</label>
                        <p id="accounts_holder">{{ get_bank_account_holder('personal', hold.data) }}</p>
                      </div>
                      <!-- Account Number -->
                      <div class="col-lg-12 col-md-4 form-group">
                        <label class="form-label" for="account_number">Account Number</label>
                        <p id="account_number">{{ get_bank_account_number('personal', hold.data) }}</p>
                      </div>
                      <!-- Sort Code -->
                      <div class="col-lg-12 col-md-4 form-group">
                        <label class="form-label" for="sort_code">Sort Code</label>
                        <p id="sort_code">{{ get_bank_sort_code('personal', hold.data) }}</p>
                      </div>
                      <!-- Building Society Ref Number -->
                      <div class="col-lg-12 col-md-4 form-group">
                        <label class="form-label" for="bsoc_ref">Building Society Ref Number</label>
                        <p id="bsoc_ref">{{ get_bank_building_soc_number('personal', hold.data) }}</p>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </b-tab>
            <b-tab title="BUSINESS INFO" v-if="check_employment_type_not_paye_and_not_null(hold.data)">
              <div class="row">
                <div class="col-12">
                  <b-card header="Current Employment Status" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                    <div class="row">
                      <!-- Current Status -->
                      <div class="col-xl-6 form-group">
                        <label class="form-label" for="business_employment_status">Current Status</label>
                        <p id="business_employment_status">
                          <span v-if="check_not_null(hold.data.worker_company_info.employment_type_id)">
                            {{ get_current_employment_type(hold.data.worker_company_info.employment_type_id) }}
                          </span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Job Title -->
                      <div class="col-xl-6 form-group">
                        <label class="form-label" for="business_job_title">Job Title</label>
                        <p id="business_job_title">
                          <span v-if="check_not_null(hold.data.worker_profile.job_title_id)">{{ get_job_title(hold.data.worker_profile.job_title_id) }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                    </div>
                  </b-card>
                </div>
                <div class="col-12">
                  <b-card :header="get_current_employment_type(hold.data.worker_company_info.employment_type_id) + ' Information'"
                          header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                    <div class="row">
                      <!-- Self Employed UTR Number -->
                      <div class="col-xl-3 col-lg-6 form-group">
                        <label class="form-label" for="personal_utr_number">Self Employed UTR Number</label>
                        <p id="personal_utr_number">
                          <span v-if="check_not_null(hold.data.worker_profile.personal_utr_number)">{{ hold.data.worker_profile.personal_utr_number }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Trading Name -->
                      <div class="col-xl-3 col-lg-6 form-group">
                        <label class="form-label" for="company_trading_name">Trading Name</label>
                        <p id="company_trading_name">
                          <span v-if="check_not_null(hold.data.worker_company_info.company_trading_name)">{{ hold.data.worker_company_info.company_trading_name }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Company UTR Number -->
                      <div class="col-xl-3 col-lg-6 form-group" v-if="hold.data.worker_company_info.employment_type_id === 32">
                        <label class="form-label" for="company_utr_number">Ltd Company UTR Number</label>
                        <p id="company_utr_number">
                          <span v-if="check_not_null(hold.data.worker_company_info.company_utr_number)">{{ hold.data.worker_company_info.company_utr_number }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Limited Company LTD Number -->
                      <div v-if="hold.data.worker_company_info.employment_type_id === 32" class="col-xl-3 col-lg-6 form-group">
                        <label class="form-label" for="company_ltd_reg_number">LTD Registration Number</label>
                        <p id="company_ltd_reg_number">
                          <span v-if="check_not_null(hold.data.worker_company_info.company_ltd_ref_number)">{{ hold.data.worker_company_info.company_ltd_ref_number }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- VAT Registered -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">{{ get_current_employment_type(hold.data.worker_company_info.employment_type_id) }} VAT Registered</h5>
                      </div>
                      <!-- UK VAT Registered -->
                      <div class="col-xl-3 col-lg-6 form-group">
                        <label class="form-label" for="company_vat_registered">UK VAT Registered</label>
                        <p id="company_vat_registered">
                          <span v-if="hold.data.worker_company_info.vat_registered">Yes</span>
                          <span v-else>No</span>
                        </p>
                      </div>
                      <!-- VAT Number -->
                      <div v-if="hold.data.worker_company_info.vat_registered" class="col-xl-3 col-lg-6 form-group">
                        <label class="form-label" for="company_vat_number">VAT Number</label>
                        <p id="company_vat_number">
                          <span v-if="check_not_null(hold.data.worker_company_info.vat_number)">{{ hold.data.worker_company_info.vat_number }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Company Address -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                    </div>
                    <div class="row" v-if="check_address_exists('company', hold.data)">
                      <div class="col-12">
                        <h5 class="font-weight-bold">{{ get_current_employment_type(hold.data.worker_company_info.employment_type_id) }} Company Address</h5>
                      </div>
                      <!-- CA Full Address -->
                      <div class="col-12 form-group">
                        <label class="form-label" for="company_address_full">Full Address</label>
                        <p id="company_address_full">{{ get_address_full('company', hold.data) }}</p>
                      </div>
                      <!-- CA Building -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_address_building">Building</label>
                        <p id="company_address_building">{{ get_address_building('company', hold.data) }}</p>
                      </div>
                      <!-- CA Street -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_address_street">Street</label>
                        <p id="company_address_street">{{ get_address_street('company', hold.data) }}</p>
                      </div>
                      <!-- CA Locality -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_address_locality">Locality</label>
                        <p id="company_address_locality">{{ get_address_locality('company', hold.data) }}</p>
                      </div>
                      <!-- CA City/Town -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_address_city_town">City / Town</label>
                        <p id="company_address_city_town">{{ get_address_city_town('company', hold.data) }}</p>
                      </div>
                      <!-- CA County -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_address_county">County</label>
                        <p id="company_address_county">{{ get_address_county('company', hold.data) }}</p>
                      </div>
                      <!-- CA Postcode -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_address_postcode">Postcode</label>
                        <p id="company_address_postcode">{{ get_address_postcode('company', hold.data) }}</p>
                      </div>
                    </div>
                    <div class="row" v-if="check_bank_exists('company', hold.data)">
                      <!-- Company Bank Account -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">{{ get_current_employment_type(hold.data.worker_company_info.employment_type_id) }} Bank Account</h5>
                      </div>
                      <!-- CB Bank Name -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_bank_name">Bank Name</label>
                        <p id="company_bank_name">{{ get_bank_name('company', hold.data) }}</p>
                      </div>
                      <!-- CB Branch Location -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_branch_location">Branch Location</label>
                        <p id="company_branch_location">{{ get_bank_branch_location('company', hold.data) }}</p>
                      </div>
                      <!-- CB Account Holder Name('s) -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_bank_accounts_holder">Account Holder Name('s)</label>
                        <p id="company_bank_accounts_holder">{{ get_bank_account_holder('company', hold.data) }}</p>
                      </div>
                      <!-- CB Account Number -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_bank_account_number">Account Number</label>
                        <p id="company_bank_account_number">{{ get_bank_account_number('company', hold.data) }}</p>
                      </div>
                      <!-- CB Sort Code -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_sort_code">Sort Code</label>
                        <p id="company_sort_code">{{ get_bank_sort_code('company', hold.data) }}</p>
                      </div>
                      <!-- CB Building Society Ref Number -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="company_bsoc_ref">Building Society Ref Number</label>
                        <p id="company_bsoc_ref">{{ get_bank_building_soc_number('company', hold.data) }}</p>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </b-tab>
            <b-tab title="RESOURCING/RECRUITMENT INFO" v-if="hold.data.worker_recruitment_info.length > 0 || Object.keys(hold.data.worker_recruitment_info).length > 0">
              <div class="row">
                <div class="col-12">
                  <b-card header="Recruitment / Resourcing" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                    <div class="row">
                      <!-- Placement Types -->
                      <div class="col-xl-4 col-lg-6 form-group">
                        <label class="form-label" for="job_types">Placement Types</label>
                        <p id="job_types">
                          <span v-if="hold.data.worker_recruitment_info.job_types !== null" v-for="(v, n) in JSON.parse(hold.data.worker_recruitment_info.job_types)">
                            {{ v.value }}
                            <span v-if="JSON.parse(hold.data.worker_recruitment_info.job_types).length > 1 && (n + 1)
                            < JSON.parse(hold.data.worker_recruitment_info.job_types).length"> ,</span>
                          </span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Industries -->
                      <div class="col-xl-4 col-lg-6 form-group">
                        <label class="form-label" for="industries">Industries</label>
                        <p id="industries">
                          <span v-if="hold.data.worker_recruitment_info.industries !== null" v-for="(v, n) in JSON.parse(hold.data.worker_recruitment_info.industries)">
                            {{ v.sector.replace(/\s+/g, '&nbsp;') }}
                            <span v-if="JSON.parse(hold.data.worker_recruitment_info.industries).length > 1 && (n + 1)
                            < JSON.parse(hold.data.worker_recruitment_info.industries).length"> ,</span>
                          </span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Job Titles -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="job_titles">Industries</label>
                        <p id="job_titles">
                          <span v-if="hold.data.worker_recruitment_info.job_titles !== null" v-for="(v, n) in JSON.parse(hold.data.worker_recruitment_info.job_titles)">
                            {{ v.job_title.replace(/\s+/g, '&nbsp;') }}
                            <span v-if="JSON.parse(hold.data.worker_recruitment_info.job_titles).length > 1 && (n + 1)
                            < JSON.parse(hold.data.worker_recruitment_info.job_titles).length"> ,</span>
                          </span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Health & Disabilities -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">Health &amp; Disabilities</h5>
                      </div>
                      <!-- Any Health problems or disabilities? -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="any_health_disability">Any Health problems or disabilities?</label>
                        <p id="any_health_disability">
                          <span v-if="hold.data.worker_recruitment_info.any_health_disability">Yes</span>
                          <span v-else>No</span>
                        </p>
                      </div>
                      <!-- Health/Disability Detail -->
                      <div class="col-xl-4 form-group" v-if="hold.data.worker_recruitment_info.any_health_disability">
                        <label class="form-label" for="health_disability_details">Health/Disability Detail</label>
                        <p id="health_disability_details">
                          <span v-if="check_not_null(hold.data.worker_recruitment_info.health_disability_details)"
                                v-html="hold.data.worker_recruitment_info.health_disability_details"></span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Special Requirements -->
                      <div class="col-xl-4 form-group" v-if="hold.data.worker_recruitment_info.any_health_disability">
                        <label class="form-label" for="health_disability_special_requirements">Special Requirements</label>
                        <p id="health_disability_special_requirements">
                          <span v-if="check_not_null(hold.data.worker_recruitment_info.health_disability_special_requirements)"
                                v-html="hold.data.worker_recruitment_info.health_disability_special_requirements"></span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Travel -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">Travel</h5>
                      </div>
                      <!-- Have own transport? -->
                      <div class="col-lg-6 form-group">
                        <label class="form-label" for="have_own_transport">Have own transport?</label>
                        <p id="have_own_transport">
                          <span v-if="hold.data.worker_recruitment_info.have_own_transport">Yes</span>
                          <span v-else-if="!hold.data.worker_recruitment_info.have_own_transport">No</span>
                        </p>
                      </div>
                      <!-- Distance willing to travel? -->
                      <div class="col-lg-6 form-group">
                        <label class="form-label" for="distance_willing_to_travel">Distance willing to travel?</label>
                        <p id="distance_willing_to_travel">
                          <span v-if="check_not_null(hold.data.worker_recruitment_info.distance_willing_to_travel)">
                            {{ hold.data.worker_recruitment_info.distance_willing_to_travel }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Criminal Convictions -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">Criminal Convictions</h5>
                      </div>
                      <!-- Have any past or pending Criminal Convictions? -->
                      <div class="col-lg-6 form-group">
                        <label class="form-label" for="any_criminal_convictions">Have any past or pending Criminal Convictions?</label>
                        <p id="any_criminal_convictions">
                          <span v-if="hold.data.worker_recruitment_info.any_criminal_convictions">Yes</span>
                          <span v-else-if="!hold.data.worker_recruitment_info.any_criminal_convictions">No</span>
                        </p>
                      </div>
                      <!-- Criminal Conviction(s) Detail -->
                      <div class="col-lg-6 form-group">
                        <label class="form-label" for="criminal_convictions_details">Criminal Conviction(s) Detail</label>
                        <p id="criminal_convictions_details">
                          <span v-if="check_not_null(hold.data.worker_recruitment_info.criminal_convictions_details)"
                                v-html="hold.data.worker_recruitment_info.criminal_convictions_details"></span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Eduction/Qualifications -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">Eduction / Qualifications</h5>
                      </div>
                      <!-- Education -->
                      <div class="col-lg-6 form-group">
                        <label class="form-label" for="education">Education</label>
                        <p id="education">
                          <span v-if="check_not_null(hold.data.worker_recruitment_info.education)" v-html="hold.data.worker_recruitment_info.education"></span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Qualifications -->
                      <div class="col-xl-4 form-group">
                        <label class="form-label" for="qualifications">Qualifications</label>
                        <p id="qualifications">
                          <span v-if="check_not_null(hold.data.worker_recruitment_info.qualifications)"
                                v-for="(v, n) in JSON.parse(hold.data.worker_recruitment_info.qualifications)">
                            {{ v.qualification.replace(/\s+/g, '&nbsp;') }}
                            <span v-if="JSON.parse(hold.data.worker_recruitment_info.qualifications).length > 1 && (n + 1)
                            < JSON.parse(hold.data.worker_recruitment_info.qualifications).length"> ,</span>
                          </span>
                          <span v-else>&nbsp;</span>
                        </p>
                      </div>
                      <!-- Previous Employment -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">Previous Employment</h5>
                      </div>
                      <!-- Employer 1 -->
                      <div class="col-lg-6 form-group">
                        <div class="row">
                          <div class="col-12">
                            <p class="font-weight-bold pt-0 mb-2">Employer 1</p>
                          </div>
                          <!-- Employer 1 Company Name -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_1_company">Company Name</label>
                            <p id="prev_emp_1_company">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_1_company)">{{ hold.data.worker_recruitment_info.prev_emp_1_company }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 1 Company Address -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_1_address">Company Address</label>
                            <p id="prev_emp_1_address">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_1_address)">{{ hold.data.worker_recruitment_info.prev_emp_1_address }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 1 Start Date -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_1_start_date">Start Date</label>
                            <p id="prev_emp_1_start_date">
                              <span
                                  v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_1_start_date)">
                                {{ hold.data.worker_recruitment_info.prev_emp_1_start_date }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 1 End Date -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_1_end_date">End Date</label>
                            <p id="prev_emp_1_end_date">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_1_end_date)">{{ hold.data.worker_recruitment_info.prev_emp_1_end_date }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 1 Position -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_1_position">Position</label>
                            <p id="prev_emp_1_position">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_1_position)">{{ hold.data.worker_recruitment_info.prev_emp_1_position }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 1 Salary/wage -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_1_salary">Salary/wage</label>
                            <p id="prev_emp_1_salary">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_1_salary)">{{ hold.data.worker_recruitment_info.prev_emp_1_salary }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 1 Reason for Leaving -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_1_reason_for_leaving">Reason for Leaving</label>
                            <p id="prev_emp_1_reason_for_leaving">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_1_reason_for_leaving)"
                                    v-html="hold.data.worker_recruitment_info.prev_emp_1_reason_for_leaving"></span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- Employer 2 -->
                      <div class="col-lg-6 form-group">
                        <div class="row">
                          <div class="col-12">
                            <p class="font-weight-bold pt-0 mb-2">Employer 2</p>
                          </div>
                          <!-- Employer 2 Company Name -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_2_company">Company Name</label>
                            <p id="prev_emp_2_company">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_2_company)">{{ hold.data.worker_recruitment_info.prev_emp_2_company }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 2 Company Address -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_2_address">Company Address</label>
                            <p id="prev_emp_2_address">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_2_address)">{{ hold.data.worker_recruitment_info.prev_emp_2_address }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 2 Start Date -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_2_start_date">Start Date</label>
                            <p id="prev_emp_2_start_date">
                              <span
                                  v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_2_start_date)">
                                {{ hold.data.worker_recruitment_info.prev_emp_2_start_date }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 2 End Date -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_2_end_date">End Date</label>
                            <p id="prev_emp_2_end_date">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_2_end_date)">{{ hold.data.worker_recruitment_info.prev_emp_2_end_date }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 2 Position -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_2_position">Position</label>
                            <p id="prev_emp_2_position">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_2_position)">{{ hold.data.worker_recruitment_info.prev_emp_2_position }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 2 Salary/wage -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_2_salary">Salary/wage</label>
                            <p id="prev_emp_2_salary">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_2_salary)">{{ hold.data.worker_recruitment_info.prev_emp_2_salary }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Employer 2 Reason for Leaving -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="prev_emp_2_reason_for_leaving">Reason for Leaving</label>
                            <p id="prev_emp_2_reason_for_leaving">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.prev_emp_2_reason_for_leaving)"
                                    v-html="hold.data.worker_recruitment_info.prev_emp_2_reason_for_leaving"></span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- References -->
                      <div class="col-12">
                        <hr class="mt-0">
                      </div>
                      <div class="col-12">
                        <h5 class="font-weight-bold">References</h5>
                      </div>
                      <!-- Reference 1 -->
                      <div class="col-lg-6 form-group">
                        <div class="row">
                          <div class="col-12">
                            <p class="font-weight-bold pt-0 mb-2">Reference 1</p>
                          </div>
                          <!-- Name -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_1_name">Name</label>
                            <p id="reference_1_name">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.reference_1_name)">{{ hold.data.worker_recruitment_info.reference_1_name }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Relationship -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_1_company_relationship">Relationship</label>
                            <p id="reference_1_company_relationship">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.reference_1_company_relationship)">
                                {{ hold.data.worker_recruitment_info.reference_1_company_relationship }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Telephone -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_1_telephone">Telephone</label>
                            <p id="reference_1_telephone">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.reference_1_telephone)">
                                {{ hold.data.worker_recruitment_info.reference_1_telephone }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Email -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_1_email">Email</label>
                            <p id="reference_1_email">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.reference_1_email)">{{ hold.data.worker_recruitment_info.reference_1_email }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- Reference 2 -->
                      <div class="col-lg-6 form-group">
                        <div class="row">
                          <div class="col-12">
                            <p class="font-weight-bold pt-0 mb-2">Reference 2</p>
                          </div>
                          <!-- Name -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_2_name">Name</label>
                            <p id="reference_2_name">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.reference_2_name)">{{ hold.data.worker_recruitment_info.reference_2_name }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Relationship -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_2_company_relationship">Relationship</label>
                            <p id="reference_2_company_relationship">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.reference_2_company_relationship)">
                                {{ hold.data.worker_recruitment_info.reference_2_company_relationship }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Telephone -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_2_telephone">Telephone</label>
                            <p id="reference_2_telephone">
                              <span
                                  v-if="check_not_null(hold.data.worker_recruitment_info.reference_2_telephone)">
                                {{ hold.data.worker_recruitment_info.reference_2_telephone }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                          <!-- Email -->
                          <div class="col-lg-6 form-group">
                            <label class="form-label" for="reference_2_email">Email</label>
                            <p id="reference_2_email">
                              <span v-if="check_not_null(hold.data.worker_recruitment_info.reference_2_email)">{{ hold.data.worker_recruitment_info.reference_2_email }}</span>
                              <span v-else>&nbsp;</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </b-tab>
          </b-tabs>

        </div>
      </div>

      <div class="row">
        <div class="col-4"></div>
      </div>
    </div>
  </div>
</template>
<script>
import uploadInput from 'partials/files/fileInput';
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: 'import_worker',
  components: {
    uploadInput,
    BootstrapToggle
  },
  data() {
    return {
      workerImportFile: null,
      holding: [],

      ni_number_exists: false,
      ni_number_record: {},
      website_email_exists: false,
      website_email_record: {},

      send_welcome_email: false,
      importing: false,
    }
  },
  methods: {
    update_import_file(file) {
      this.workerImportFile = file;
    },
    import_file_to_holding() {
      let formData = new FormData();
      formData.append('import_file', this.workerImportFile);
      formData.append('user_id', this.$store.state.auth.me.id);

      axios.post(this.crmApiPath + 'worker/import/holding/add', formData, {
             headers: {'Content-Type': 'application/json'}
           })
           .then(() => {
             // clear import file
             this.workerImportFile = null;
             axios.get(this.crmApiPath + 'worker/import/holding/get', {
               params: {
                 user_id: this.$store.state.auth.me.id
               }
             }).then(res => {
               if (res.data.length > 0) {
                 // check record for matching website email or ni number
                 let ni_number = res.data[0].data.worker_profile.ni_number;
                 let website_email = null;
                 if (this.check_email_exists('website_login', res.data[0].data)) {
                   website_email = this.get_email('website_login', res.data[0].data)
                 }
                 axios.post(this.crmApiPath + 'worker/import/holding/check_existing_record', {
                   ni_number: ni_number,
                   website_email: website_email
                 }).then(check => {
                   this.ni_number_exists = check.data.ni_number_exists;
                   if (check.data.ni_number_exists) {
                     this.ni_number_record = check.data.ni_number_record
                   }
                   this.website_email_exists = check.data.website_email_exists
                   if (check.data.website_email_exists) {
                     this.website_email_record = check.data.website_email_record
                   }
                   this.holding = res.data;
                 })
               }
             })
           });
    },
    /**
     * holding display functions
     */
    check_not_null(value) {
      if (typeof value === "undefined") {
        return false
      }
      else if (isNaN(value)) {
        return value !== null && Object.keys(value).length > 1;
      }
      else {
        return value !== null
      }
    },
    /**
     * Email Addresses
     */
    check_email_exists(type, record) {
      // check if record exists
      if (type === 'website_login') {
        return record.worker_emails.find(email => email.email_type_id === 67) !== undefined;
      }
      if (type === 'person_email') {
        return record.worker_emails.find(email => email.email_type_id === 64) !== undefined;
      }
      if (type === 'alternative_email') {
        return record.worker_emails.find(email => email.email_type_id === 65) !== undefined;
      }
      if (type === 'business_email') {
        return record.worker_emails.find(email => email.email_type_id === 66) !== undefined;
      }
    },
    get_email(type, record) {
      // return email address based on type requested
      if (type === 'website_login') {
        return record.worker_emails.find(email => email.email_type_id === 67).email_address
      }
      if (type === 'person_email') {
        return record.worker_emails.find(email => email.email_type_id === 64).email_address
      }
      if (type === 'alternative_email') {
        return record.worker_emails.find(email => email.email_type_id === 65).email_address
      }
      if (type === 'business_email') {
        return record.worker_emails.find(email => email.email_type_id === 66).email_address
      }
    },
    /**
     * Phone Number
     */
    check_phone_exists(type, record) {
      // check if record exists
      if (type === 'personal_mobile') {
        return record.worker_phones.find(phone => phone.phone_type_id === 59) !== undefined;
      }
      if (type === 'personal_landline') {
        return record.worker_phones.find(phone => phone.phone_type_id === 58) !== undefined;
      }
    },
    get_phone(type, record) {
      // return phone number based on type requested
      if (type === 'personal_mobile') {
        return record.worker_phones.find(phone => phone.phone_type_id === 59).phone_number
      }
      if (type === 'personal_landline') {
        return record.worker_phones.find(phone => phone.phone_type_id === 58).phone_number
      }
    },
    /**
     * Addresses
     */
    check_address_exists(type, record) {
      // check if record exists
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47) !== undefined
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48) !== undefined
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49) !== undefined
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106) !== undefined
      }
    },
    get_address_full(type, record) {
      // return full address based on type requested
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47).full
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48).full
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49).full
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106).full
      }
    },
    get_address_building(type, record) {
      // return building part of address based on type requested
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47).building
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48).building
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49).building
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106).building
      }
    },
    get_address_street(type, record) {
      // return street part of address based on type requested
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47).street
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48).street
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49).street
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106).street
      }
    },
    get_address_locality(type, record) {
      // return locality part of address based on type requested
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47).locality
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48).locality
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49).locality
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106).locality
      }
    },
    get_address_city_town(type, record) {
      // return city/town part of address based on type requested
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47).city_town
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48).city_town
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49).city_town
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106).city_town
      }
    },
    get_address_county(type, record) {
      // return county part of address based on type requested
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47).county
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48).county
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49).county
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106).county
      }
    },
    get_address_postcode(type, record) {
      // return postcode part of address based on type requested
      if (type === 'home_address') {
        return record.worker_addresses.find(address => address.address_type_id === 47).postcode
      }
      if (type === 'second_home') {
        return record.worker_addresses.find(address => address.address_type_id === 48).postcode
      }
      if (type === 'term_time') {
        return record.worker_addresses.find(address => address.address_type_id === 49).postcode
      }
      if (type === 'company') {
        return record.worker_addresses.find(address => address.address_type_id === 106).postcode
      }
    },
    /**
     * Personal Information
     */
    get_person_title(id) {
      return this.$store.state.crm_options.person_title.find(t => t.id === id).value
    },
    get_person_nationality(id) {
      return this.$store.state.crm_options.nationalities.find(n => n.id === id).nationality
    },
    /**
     * Current Employment Status
     */
    get_current_employment_type(id) {
      return this.$store.state.crm_options.worker_employment_type.find(e => e.id === id).value;
    },
    get_job_title(id) {
      return this.$store.state.crm_options.job_titles.find(jt => jt.id === id).job_title;
    },
    /**
     * Bank Records
     */
    check_bank_exists(type, record) {
      if (type === 'personal') {
        return record.worker_banks.find(bank => bank.bank_type_id === 39) !== undefined
      }
      if (type === 'company') {
        return record.worker_banks.find(bank => bank.bank_type_id === 40) !== undefined
      }
    },
    get_bank_name(type, record) {
      if (type === 'personal') {
        return record.worker_banks.find(bank => bank.bank_type_id === 39).bank_name
      }
      if (type === 'company') {
        return record.worker_banks.find(bank => bank.bank_type_id === 40).bank_name
      }
    },
    get_bank_branch_location(type, record) {
      if (type === 'personal') {
        return record.worker_banks.find(bank => bank.bank_type_id === 39).branch_location
      }
      if (type === 'company') {
        return record.worker_banks.find(bank => bank.bank_type_id === 40).branch_location
      }
    },
    get_bank_account_holder(type, record) {
      if (type === 'personal') {
        return record.worker_banks.find(bank => bank.bank_type_id === 39).accounts_holder
      }
      if (type === 'company') {
        return record.worker_banks.find(bank => bank.bank_type_id === 40).accounts_holder
      }
    },
    get_bank_account_number(type, record) {
      if (type === 'personal') {
        return record.worker_banks.find(bank => bank.bank_type_id === 39).account_number
      }
      if (type === 'company') {
        return record.worker_banks.find(bank => bank.bank_type_id === 40).account_number
      }
    },
    get_bank_sort_code(type, record) {
      if (type === 'personal') {
        return record.worker_banks.find(bank => bank.bank_type_id === 39).sort_code
      }
      if (type === 'company') {
        return record.worker_banks.find(bank => bank.bank_type_id === 40).sort_code
      }
    },
    get_bank_building_soc_number(type, record) {
      if (type === 'personal') {
        return record.worker_banks.find(bank => bank.bank_type_id === 39).building_society_ref
      }
      if (type === 'company') {
        return record.worker_banks.find(bank => bank.bank_type_id === 40).building_society_ref
      }
    },
    /**
     * Check not PAYE
     */
    check_employment_type_not_paye_and_not_null(record) {
      return !(record.worker_company_info.employment_type_id === null || record.worker_company_info.employment_type_id === 33);
    },
    /**
     * GO TO PROFILE found from record if matched against website login or ni number
     */
    go_to_profile(passed_id) {
      let worker_id = null;
      if (passed_id === undefined) {
        if (this.website_email_exists && !this.ni_number_exists) {
          worker_id = this.website_email_record.worker_id
        }
        else if (!this.website_email_exists && this.ni_number_exists) {
          worker_id = this.ni_number_record.worker_id
        }
        else if (this.website_email_exists && this.ni_number_exists) {
          worker_id = this.website_email_record.worker_id
        }
      }
      else {
        worker_id = passed_id
      }

      this.$store.commit('CURRENT_PROFILE_WORKER_ID', worker_id);
      this.$store.commit('SET_WORKER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$tabs.close({
          path: this.$router.currentRoute.fullPath,
          to: '/workers/profile',
        });
        this.$tabs.refresh('/workers/profile', true);
      });
    },
    /**
     *
     */
    import_worker() {
      this.importing = true;
      axios.post(this.crmApiPath + 'worker/import', {
        holding_id: this.holding[0].id,
        send_welcome_email: this.send_welcome_email,
        welcome_email: this.get_email('website_login', this.holding[0].data),
        person: this.holding[0].data.person,
        worker: this.holding[0].data.worker,
        worker_profile: this.holding[0].data.worker_profile,
        worker_company_info: this.holding[0].data.worker_company_info,
        worker_recruitment_info: this.holding[0].data.worker_recruitment_info,
        worker_banks: this.holding[0].data.worker_banks,
        worker_emails: this.holding[0].data.worker_emails,
        worker_phones: this.holding[0].data.worker_phones,
        worker_addresses: this.holding[0].data.worker_addresses,

        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      }).then(new_worker_id => {

        this.$snotify.confirm('', '', {
          closeOnClick: false,
          position: 'centerCenter',
          backdrop: 0.5,
          html: '<div class="snotifyToast__title">Go To Profile</div>' +
              '<div class="snotifyToast__body">' +
              'Go to the profile for ' + this.holding[0].data.person.first_name + ' ' + this.holding[0].data.person.surname +
              '</div>',
          buttons: [
            {
              text: 'Confirm', action: (toast) => {
                this.$snotify.remove(toast.id);
                this.$nextTick(() => {
                  this.go_to_profile(new_worker_id.data)
                })
              }
            },
            {
              text: 'Cancel', action: (toast) => {
                this.$snotify.remove(toast.id);

                this.workerImportFile = null;
                this.holding = [];
                this.ni_number_exists = false;
                this.ni_number_record = {};
                this.website_email_exists = false;
                this.website_email_record = {};
                this.send_welcome_email = false;
                this.importing = false;
              }
            }
          ]
        });
      })
    }
  },
}
</script>
<style scoped lang="scss">
.worker_exists {
  padding:       10px 20px;
  margin:        10px;
  background:    $red;
  color:         $white;
  border-radius: $border_radius_2;

  .we_notice {
    font-size:      1rem;
    width:          calc(100% - 160px);
    display:        inline-block;
    vertical-align: middle;
  }

  .we_btn {
    width:          150px;
    display:        inline-block;
    vertical-align: middle;
  }
}
</style>
<style lang="scss"></style>
